module.exports = __webpack_public_path__ + "static/media/arrow-left.ed177295.svg";